export function normalizeTeacherEmail(value: string) {
  return String(value || "").trim().toLowerCase();
}

export function getTeacherEmailConflictMessage(
  responsibleEmail: string,
  teacherEmails: string[]
) {
  const responsible = normalizeTeacherEmail(responsibleEmail);
  const seen = new Set<string>();

  for (const rawEmail of teacherEmails) {
    const email = normalizeTeacherEmail(rawEmail);

    if (!email) continue;

    if (responsible && email === responsible) {
      return "O e-mail de um professor adicional não pode ser igual ao e-mail do responsável do agendamento.";
    }

    if (seen.has(email)) {
      return "Não é permitido repetir o mesmo e-mail entre os professores adicionais.";
    }

    seen.add(email);
  }

  return "";
}
